export class TermsConditionModel {
  public isDeletable: boolean;
  public isChecked: boolean;
  public instanceHashId: string = "";
  public type: string = "";
  public name: string = "";
  public version: number = 1.0;
  
  
  public get displayVersion() : string {
    return this.version.toFixed(1);
  }
  
  
  public termsAndConditionsHashId: string = "";
  public bodyHtml: string = "";
  public isEditable: boolean;

  public companyHashId: string = "";
  public organizationHashId: string = "";
  public sharedVehicleGroupHashId: string = "";
  public subscriptionHashId: string = "";
  public instanceName: string = "";
  public companyName: string = "";
  public organizationName: string = "";
  public sharedVehicleGroupName: string = "";

  public acceptanceMomentModel: AcceptanceMomentModel;

  public instanceHashIdList: string[] = [];
  public companyHashIdList: string[] = [];
  public organizationHashIdList: string[] = [];
  public sharedVehicleGroupHashIdList: string[] = [];

  constructor() {
    this.acceptanceMomentModel = new AcceptanceMomentModel();
  }
}

export class AcceptanceMomentModel {
  public acceptanceMomentIdHashId: string;
  public accountActivation: boolean;
  public repeatTimeOpenApp: boolean;
  public repeatTimeInDay: number;
  public everyTimeOpenApp: boolean;
  public makeBooking: boolean;
  public startBooking: boolean;
  public openBooking: boolean;
  public ctgSelection: boolean;
  public contractTypeGroupList: string[];
}

export class TermsConditionStatus {
  public termsAndConditionsHashId: string;
  public accepted: string;
  public name: string;
  public content: string;
  public version: string;
  public entityName: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/models/terms-condition.model.ts